import { create } from 'zustand';

/** tab 选择 */
export type HealthCheckTab = 'HTTP' | 'COMMAND' | 'TCP_PORT';

/** 表单收集的数据 */
export interface HealthCheckData {
  tab?: HealthCheckTab;
  // HTTP请求 - 协议
  protocol?: 'HTTP' | 'HTTPS';
  /** 路径 */
  path?: string;
  /** HTTP端口 */
  httpPort?: number;
  // 执行的命令
  command?: string;
  // TCP端口
  tcpPort?: number;
  /** 初始延迟 */
  initialDelay?: number;
  /** 超时时间 */
  timeout?: number;
  /** 检查间隔 */
  checkPeriod?: number;
  /** 成功阈值 */
  successThreshold?: number;
  /** 失败阈值 */
  failureThreshold?: number;
}

/** 管理的状态 */
interface HealthCheckState {
  /** 是否勾选了健康检查 */
  isHealthcheckSelected?: boolean;
  /** 存货检查 */
  aliveCheck?: HealthCheckData;
  /** 就绪检查 */
  readyCheck?: HealthCheckData;
  /** 启动检查 */
  startupCheck?: HealthCheckData;
  /** 共享校验函数
   * 用于在点击确认时,校验所有的健康检查是否填写完整
   * 返回 true 表示校验通过, false 表示校验不通过
   * 注意: 只有挂载了对应的组件,才会有校验函数,否则是 undefined,注意判断
   */
  validateHealthCheck?: () => Promise<boolean>;
}

const initState: HealthCheckState = {
  isHealthcheckSelected: false,
  aliveCheck: undefined,
  readyCheck: undefined,
  startupCheck: undefined,
};

interface HealthCheckAction {
  /** 是否勾选 健康检查 */
  toggleHealthcheckSelected: (checked: boolean) => void;
  /** 共享校验函数 */
  setValidateHealthCheck: (validateFields: () => Promise<boolean>) => void;
  /** 更新存货检查 */
  updateAliveCheck: (data: HealthCheckData) => void;
  removeAliveCheck: () => void;
  /** 更新就绪检查 */
  updateReadyCheck: (data: HealthCheckData) => void;
  removeReadyCheck: () => void;
  /** 更新启动检查 */
  updateStartupCheck: (data: HealthCheckData) => void;
  removeStartupCheck: () => void;
  reset: () => void;
}

export const useHealthCheckStore = create<HealthCheckState & HealthCheckAction>()((set) => ({
  ...initState,
  toggleHealthcheckSelected: (checked) => set({ isHealthcheckSelected: checked }),
  setValidateHealthCheck: (validateHealthCheck) => set({ validateHealthCheck }),
  updateAliveCheck: (data) => set({ aliveCheck: data }),
  removeAliveCheck: () => set({ aliveCheck: undefined }),
  updateReadyCheck: (data) => set({ readyCheck: data }),
  removeReadyCheck: () => set({ readyCheck: undefined }),
  updateStartupCheck: (data) => set({ startupCheck: data }),
  removeStartupCheck: () => set({ startupCheck: undefined }),
  reset: () => set(initState),
}));
